export const isTypeOf = require('./is-type-of').default;
export const isInstanceOf = require('./is-instance-of').default;
export const isEmail = require('./is-email').default;
